/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import { NON_RKPAY_INVOICE_COLUMNS } from "@constants";
import classNames from "classnames";
import PropTypes from "prop-types";
import utils from "@utils";
import { ScrollDetect } from "../../../../components";

const PendingJobsTable = ({
	updateSort,
	selectAllRecords,
	multipleSelection,
	filters,
	records,
	goToJob,
	selectedRecords,
	updateSelectedRecord,
	user,
	addToInvoice,
	hasMoreRecords,
	loadNextPage,
}) => {
	const { lang } = global;

	return (
		<>
			<div className="row hidden-xs hidden-sm hidden-md invoice-columns">
				<div className="col-md-1 col-lg-1">
					<If condition={filters.clientId}>
						<label
							htmlFor="checkbox_all"
							className="selector-label margin-right-12"
						>
							<input
								type="checkbox"
								id="checkbox_all"
								name="selectAllItems"
								onChange={() => selectAllRecords()}
								onClick={e => e.stopPropagation()}
								aria-label="Select All Items"
							/>
						</label>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.JobId)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.JobId);
					}}
				>
					<If condition={multipleSelection}>
						<label
							htmlFor="checkbox_all"
							className="selector-label margin-right-12"
						>
							<input
								type="checkbox"
								id="checkbox_all"
								name="selectAllItems"
								onChange={() => selectAllRecords()}
								onClick={e => e.stopPropagation()}
								aria-label="Select All Items"
								disabled
							/>
						</label>
					</If>
					<span className="font-semi-bold">{lang.t("Job")} #</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.JobId}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Client)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Client);
					}}
				>
					<span className="font-semi-bold">{lang.t("Client")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Client}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.JobDate)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.JobDate);
					}}
				>
					<span className="font-semi-bold">{lang.t("Job Date")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.JobDate}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.JobName)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.JobName);
					}}
				>
					<span className="font-semi-bold">{lang.t("Job Name")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.JobName}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-2 col-lg-2 hidden-xs hidden-md" />
			</div>
			<div className="hidden-xs hidden-sm hidden-md invoice-columns-body">
				{records.length > 0 &&
					records.map(item => (
						<div
							key={`${item.Id}-${item.InvoiceNumber}`}
							className={classNames("row", { disabled: item.disabled })}
							role="button"
							onClick={() => item.disabled && goToJob(item.Id)}
							tabIndex={0}
						>
							<div className="checkbox col-md-1 col-lg-1">
								<label htmlFor={`checkbox_${item?.Id}`}>
									<input
										type="checkbox"
										id={`checkbox_${item.Id}`}
										name="selectInvoice"
										checked={selectedRecords[item.Id]}
										onChange={() => updateSelectedRecord(item)}
										onClick={e => e.stopPropagation()}
										aria-label="Select Job"
										disabled={item.disabled}
									/>
								</label>
							</div>
							<div className="col-md-2 col-lg-2">
								<If condition={multipleSelection}>
									<label
										htmlFor={`check_${item.Id}`}
										className="selector-label margin-right-12"
									>
										<input
											type="checkbox"
											id={`check_${item.Id}`}
											name="selectItem"
											checked={selectedRecords[item.Id]}
											onChange={() => updateSelectedRecord(item)}
											onClick={e => e.stopPropagation()}
											aria-label="Select Item"
											disabled
										/>
									</label>
								</If>
								<span>{item.Id}</span>
							</div>
							<div
								className="col-md-2 col-lg-2 truncate"
								title={item.ClientName}
							>
								<span>{item.ClientName}</span>
							</div>
							<div className="col-md-2 col-lg-2">
								<span>
									{utils.formatDate(
										item.StartDateTime,
										"en-US",
										user.TimeZoneId,
										"numeric",
									)}
								</span>
							</div>
							<div
								className="col-md-2 col-lg-2 truncate"
								title={item.JobName}
							>
								<span>{item.JobName}</span>
							</div>
							<div className="col-lg-2 actions-column">
								<button
									type="button"
									className="btn btn-primary btn-block add-to__invoice grow"
									onClick={e => {
										e.stopPropagation();
										addToInvoice(item);
									}}
									data-prevent-navigation
									disabled={item.disabled}
								>
									{lang.t("Add to Invoice")}
								</button>
							</div>
						</div>
					))}
			</div>
			<div className="hidden-lg">
				{records.length > 0 &&
					records.map(item => (
						<div key={`${item.Id}-${item.InvoiceNumber}`} className="row">
							<div className="invoice-card">
								<div className="card-item">
									<span className="font-semi-bold">{lang.t("Job")} #:&nbsp;</span>
									<span>{item.Id}</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Client")}:&nbsp;
									</span>
									<span>{item.ClientName}</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Job Date")}:&nbsp;
									</span>
									<span>
										{utils.formatDate(
											item.StartDateTime,
											"en-US",
											user.TimeZoneId,
											"numeric",
										)}
									</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Paid Date")}:&nbsp;
									</span>
									<span>
										{utils.formatDate(
											item.PaidDate,
											"en-US",
											user.TimeZoneId,
											"numeric",
										)}
									</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Job Name")}:&nbsp;
									</span>
									<span>{item.JobName}</span>
								</div>
								<div className="actions">
									<button
										type="button"
										className="btn btn-primary btn-block add-to__invoice grow"
										onClick={e => {
											e.stopPropagation();
											addToInvoice(item);
										}}
										data-prevent-navigation
										disabled={item.disabled}
									>
										{lang.t("Add to Invoice")}
									</button>
								</div>
							</div>
						</div>
					))}
			</div>
			<If condition={hasMoreRecords}>
				<ScrollDetect
					className="text-center"
					onVisible={() => loadNextPage()}
				>
					<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
				</ScrollDetect>
			</If>
		</>
	);
};

PendingJobsTable.propTypes = {
	updateSort: PropTypes.func,
	selectAllRecords: PropTypes.func,
	multipleSelection: PropTypes.bool,
	filters: PropTypes.object,
	records: PropTypes.array,
	goToJob: PropTypes.func,
	selectedRecords: PropTypes.object,
	updateSelectedRecord: PropTypes.func,
	user: PropTypes.object,
	addToInvoice: PropTypes.func,
	hasMoreRecords: PropTypes.bool,
	loadNextPage: PropTypes.func,
};

export default PendingJobsTable;
